var map = {
	"./aed.png": 890,
	"./aud.png": 891,
	"./bgn.png": 892,
	"./bhd.png": 893,
	"./cad.png": 894,
	"./chf.png": 895,
	"./cnh.png": 896,
	"./cny.png": 897,
	"./czk.png": 898,
	"./dkk.png": 899,
	"./eur.png": 900,
	"./gbp.png": 901,
	"./hkd.png": 902,
	"./hrk.png": 903,
	"./huf.png": 904,
	"./idr.png": 905,
	"./ils.png": 906,
	"./inr.png": 907,
	"./jpy.png": 908,
	"./kes.png": 909,
	"./kwd.png": 910,
	"./mxn.png": 911,
	"./myr.png": 912,
	"./nok.png": 913,
	"./nzd.png": 914,
	"./omr.png": 915,
	"./php.png": 916,
	"./pln.png": 917,
	"./qar.png": 918,
	"./ron.png": 919,
	"./rub.png": 920,
	"./sar.png": 921,
	"./sek.png": 922,
	"./sgd.png": 923,
	"./thb.png": 924,
	"./try.png": 925,
	"./ugx.png": 926,
	"./usd.png": 927,
	"./zar.png": 928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 889;